import { matches } from '../object-utils';

const codeEditFilter = (codeEdits: CMxCommonApp.CodeEditInputs) => {
  return {
    filterIssues: (
      match: Partial<CMxCommonApp.EditorIssue> = {}
    ): CMxCommonApp.EditorIssue[] => {
      const values = Object.values(codeEdits);
      const issues = [...values].flat();
      return issues.filter(matches(match));
    },
    getIssuesForCode: (
      code: string,
      match: Partial<CMxCommonApp.EditorIssue> = {}
    ): CMxCommonApp.EditorIssue[] => {
      const keySet = new Set(Object.keys(codeEdits));
      const issues = keySet.has(code) ? codeEdits[code] : [];
      if (!issues?.length) {
        return issues;
      } else {
        const matcherFn = (obj: any) => {
          return Object.entries(match).every(([key, value]) => {
            if (Array.isArray(value)) {
              // allow partial matches on arrays
              // [a, b] will match [a, b, c], but not vice-versa
              let arrays = [value, obj[key]];
              return (
                arrays.reduce((a, b) => a.filter(c => !b.includes(c)))
                  .length === 0
              );
            }
            return value === obj[key];
          });
        };

        const matched = issues.filter(matcherFn);
        return matched;
      }
    }
  };
};

export { codeEditFilter };
